import { render, staticRenderFns } from "./List.vue?vue&type=template&id=f6f81712&scoped=true"
import script from "./List.vue?vue&type=script&lang=ts"
export * from "./List.vue?vue&type=script&lang=ts"
import style0 from "./List.vue?vue&type=style&index=0&id=f6f81712&prod&scoped=true&lang=css"
import style1 from "./List.vue?vue&type=style&index=1&id=f6f81712&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f81712",
  null
  
)

export default component.exports